import { IApiMatchListResult } from '../../../../modules/api/repositories/matchList/matchList.types';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export enum ESortType {
  SCORE = '-score',
  REGISTRATION_DATE = '-registration_date',
  ASC_YEARS = 'age',
  DESC_YEARS = '-age',
}
export enum ESubScore {
  PERSONALITY = 'personality',
  VISION = 'vision',
  VALUE = 'value',
}

export interface IMatchListQueryParams {
  pageNumber?: number;
  sortType?: ESortType;
  subScore?: ESubScore;
  excludedMembers?: string[];
}

export const DEFAULT_MATCHLIST_PAGE_SIZE = 10;

export const MatchlistResource = {
  getMatchlistByAccountId: (
    accountId: string,
    {
      pageNumber = 1,
      sortType,
      subScore,
      excludedMembers,
    }: IMatchListQueryParams
  ) => {
    let api = AffinyEndpoint.MatchList.url(`/${accountId}/`);

    api = api.query(`page[number]=${pageNumber}`);
    api = api.query(`page[size]=${DEFAULT_MATCHLIST_PAGE_SIZE}`);

    if (sortType) api = api.query(`sort_type=${sortType}`);

    if (subScore) api = api.query(`sub_score=${subScore}`);

    if (excludedMembers && excludedMembers.length) {
      api = api.query(`excluded_members=${excludedMembers}`);
    }

    return api.get().json<IApiMatchListResult>();
  },
};
